/* globals mApp */

export default class Loader {
  constructor(id) {
    this.id = id;
  }

  show(
    options = {
      overlayColor: '#000000',
      type: 'loader',
      state: 'dynamic',
      size: 'lg',
      message: 'Processing...',
    },
  ) {
    mApp.block(this.id, options);
  }

  showProgressLoader(message) {
    mApp.block(this.id, {
      overlayColor: '#000000',
      type: 'loader',
      state: 'dynamic',
      size: 'lg',
      message,
    });
  }

  hide() {
    mApp.unblock(this.id);
  }
}
